<template>
	<div class="bet_limitation">

		<breadcrumbs />
		<div class="content-i">
			<div class="content-box">
				<div class="row">
					<div class="col-12">
						<!--START - User List -->
						<div class="element-wrapper">
							<h6 class="element-header capitalize">
								{{ t.max_stake_per_bet_slip }}
							</h6>
							<div class="element-box">
								<generalForm :uid="uid" />
							</div>
						</div>
					</div>
					<div class="col-sm-12 col-xxl-6">
						<!--START - User List -->
						<div class="element-wrapper">
							<h6 class="element-header capitalize">
								{{ t.max_earnings_per_bet_slip }}
							</h6>
							<div class="element-box">
								<MaxEarningsForm :uid="uid" />
							</div>
						</div>
					</div>
					<div class="col-sm-12 col-xxl-6">
						<!--START - User List -->
						<div class="element-wrapper">
							<h6 class="element-header capitalize">
								{{ t.max_stake_per_bet_slip }}
							</h6>
							<div class="element-box">
								<MaxStakeForm :uid="uid" />
							</div>
						</div>
					</div>
					<div class="col-sm-12 col-xxl-6">
						<!--START - User List -->
						<div class="element-wrapper">
							<h6 class="element-header capitalize">
								{{ t.min_stake_per_bet_slip || 'Min Stake Amount' }}
							</h6>
							<div class="element-box">
								<MinStakeForm :uid="uid" />
							</div>
						</div>
					</div>
				</div>
			</div>

			<!--------------------
START - Sidebar
-------------------->
			<div class="content-panel compact">
				<div class="content-panel-close" v-on:click="controlPanel()">
					<i class="os-icon os-icon-close"></i>
				</div>
				<div class="element-wrapper">
					<div class="element-actions actions-only" v-b-toggle.filter variant="primary">
							<span class="when-opened">
								<i class="os-icon os-icon-minus-circle"></i>
							</span>
						<span class="when-closed">
								<i class="os-icon os-icon-plus-circle"></i>
							</span>
					</div>
					<h6 class="element-header" v-b-toggle.filter variant="primary">
						{{ t.filter.title }}
					</h6>
					<div class="element-box-tp">
						<b-collapse id="filter" class="mt-2">

						</b-collapse>
					</div>
				</div>

			</div>
			<!--------------------
			END - Sidebar
			-------------------->
		</div>
	</div>
</template>

<script>
	import generalForm from '@/components/configuration/form/betSlipLimitations'
	import MaxStakeForm from '@/components/configuration/form/betSlipMaxStake'
	import MaxEarningsForm from '@/components/configuration/form/betSlipMaxEarnings'
	import MinStakeForm from '@/components/configuration/form/betSlipMinStake'
    export default {
        name: 'betSlipLimitation',
	    components: {MaxStakeForm, MaxEarningsForm, generalForm, MinStakeForm},
	    prop: {
            uid:{
                default: 0,
            }
	    },
        data () {
            return {
                t: this.$root.t
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
	.bet_limitation #form #form {
		padding-top: 20px;
		height: 600px;
		overflow: auto;
	}
</style>



// WEBPACK FOOTER //
// src/components/configuration/betSlipLimitation.vue